module.exports = __webpack_public_path__ + "static/media/comingsoon-bg.f7dd69c5.jpg";